import type { ReactElement } from 'react';
import { BookImage, File, FileArchive, FileText, Folder as FolderIcon, Image as ImageIcon } from 'lucide-react';
import type { ExplorerEntry, FileKind } from '@xdocs/schemas';

const KIND_ICON: Record<FileKind, typeof File> = {
  upload: FileText,
  thumbnail: ImageIcon,
  render: FileArchive,
  illustration: ImageIcon,
  cover: BookImage,
  bundle: FileArchive,
  source: FileText,
};

/** Icon for an explorer row (F7 grid/list icon tile) — folders get a
 * distinct glyph; files switch on `fileKind`. */
export function ExplorerEntryIcon({ entry, size = 18 }: { entry: ExplorerEntry; size?: number }): ReactElement {
  if (entry.type === 'folder') return <FolderIcon size={size} aria-hidden="true" />;
  const Icon = KIND_ICON[entry.kind] ?? File;
  return <Icon size={size} aria-hidden="true" />;
}
